import Layout from "../components/layout/Layout";
import SEO from "../components/layout/SEO";
import CTAButton from "../components/shared/CTAButton";
import { useI18n } from "../i18n";

export default function NotFound() {
  const { t } = useI18n();
  return (
    <Layout>
      <SEO title="Page not found | Plastic Surgery Vietnam" description="The page you are looking for could not be found." path="/404" noindex />
      <section className="container-psv min-h-[60vh] flex flex-col items-center justify-center text-center py-24" data-testid="not-found">
        <span className="font-serif text-8xl md:text-9xl text-accent/40">404</span>
        <h1 className="font-serif font-medium text-primary text-4xl md:text-5xl mt-4">This page could not be found</h1>
        <p className="mt-5 text-lg text-secondary-foreground font-light max-w-md">The page may have moved or is still being prepared. Let us help you find what you need.</p>
        <div className="mt-8 flex flex-wrap gap-4 justify-center">
          <CTAButton to="/" testId="notfound-home-btn">{t("common.backHome")}</CTAButton>
          <CTAButton to="/procedures" variant="outline" testId="notfound-procedures-btn">{t("nav.procedures")}</CTAButton>
        </div>
      </section>
    </Layout>
  );
}
